import { IconNameType, LeadStatusEnum, LeadTypeEnum } from '@/types'
import type { BadgeVariants } from '@/ui'

export const LEAD_STATUS_VARIANTS: Record<LeadStatusEnum, BadgeVariants['variant']> = {
  [LeadStatusEnum.PENDING]: 'orange',
  [LeadStatusEnum.OPENED]: 'purple',
  [LeadStatusEnum.SENT_UNOPENED]: 'indigo',
  [LeadStatusEnum.ERROR]: 'red',
  [LeadStatusEnum.FILTERED]: 'blue',
  [LeadStatusEnum.CREATED]: 'default',
  [LeadStatusEnum.SPAM]: 'outline',
  [LeadStatusEnum.CALL_INBOUND]: 'yellow',
  [LeadStatusEnum.ORDER_COMPLETE]: 'green',
  [LeadStatusEnum.ORDER_PAID]: 'lime',
  [LeadStatusEnum.TEST]: 'secondary',
}

export const LEAD_STATUS_TITLES: Record<LeadStatusEnum, string> = {
  [LeadStatusEnum.PENDING]: 'Pending',
  [LeadStatusEnum.OPENED]: 'Opened',
  [LeadStatusEnum.SENT_UNOPENED]: 'Sent - Unopened',
  [LeadStatusEnum.ERROR]: 'Error',
  [LeadStatusEnum.FILTERED]: 'Filtered',
  [LeadStatusEnum.CREATED]: 'Created',
  [LeadStatusEnum.SPAM]: 'Spam',
  [LeadStatusEnum.CALL_INBOUND]: 'Call Inbound',
  [LeadStatusEnum.ORDER_COMPLETE]: 'Order Complete',
  [LeadStatusEnum.ORDER_PAID]: 'Order Paid',
  [LeadStatusEnum.TEST]: 'Test',
}

export const LEAD_TYPE_TITLES: Record<LeadTypeEnum, string> = {
  [LeadTypeEnum.CALL]: 'Call',
  [LeadTypeEnum.INQUIRY]: 'Inquiry',
  [LeadTypeEnum.REVIEW]: 'Review',
  [LeadTypeEnum.QUESTION]: 'Question',
  [LeadTypeEnum.SURVEY]: 'Survey',
  [LeadTypeEnum.SCHEDULED_EVENT]: 'Scheduled Event',
  [LeadTypeEnum.SMS_INQUIRY]: 'SMS Inquiry',
  [LeadTypeEnum.CHAT]: 'Chat',
  [LeadTypeEnum.CONVERSIOBOT]: 'ConversioBot',
  [LeadTypeEnum.ORDER]: 'Order',
  [LeadTypeEnum.OFFER]: 'Offer',
  [LeadTypeEnum.GOOGLE_LEAD]: 'Google Lead',
  [LeadTypeEnum.INSTANT_QUOTE]: 'Instant Quote',
}

export const LEAD_TYPE_ICONS: Record<LeadTypeEnum, IconNameType> = {
  [LeadTypeEnum.CALL]: 'PhoneXMarkIcon',
  [LeadTypeEnum.INQUIRY]: 'EnvelopeOpenIcon',
  [LeadTypeEnum.REVIEW]: 'StarIcon',
  [LeadTypeEnum.QUESTION]: 'QuestionMarkCircleIcon',
  [LeadTypeEnum.SURVEY]: 'ClipboardDocumentListIcon',
  [LeadTypeEnum.SCHEDULED_EVENT]: 'CalendarIcon',
  [LeadTypeEnum.SMS_INQUIRY]: 'ChatBubbleLeftEllipsisIcon',
  [LeadTypeEnum.CHAT]: 'ChatBubbleLeftEllipsisIcon',
  [LeadTypeEnum.CONVERSIOBOT]: 'ChatBubbleLeftEllipsisIcon',
  [LeadTypeEnum.ORDER]: 'ShoppingCartIcon',
  [LeadTypeEnum.OFFER]: 'TagIcon',
  [LeadTypeEnum.GOOGLE_LEAD]: 'GlobeAltIcon',
  [LeadTypeEnum.INSTANT_QUOTE]: 'DocumentTextIcon',
}

export const GEO_LEAD_SORT_ORDER = [
  'country',
  'countryCode',
  'region',
  'regionCode',
  'city',
  'postalCode',
  'timezone',
  'continent',
]
